import { render, staticRenderFns } from "./TitleRoute.vue?vue&type=template&id=023f78a0&scoped=true&"
import script from "./TitleRoute.vue?vue&type=script&lang=js&"
export * from "./TitleRoute.vue?vue&type=script&lang=js&"
import style0 from "./TitleRoute.vue?vue&type=style&index=0&id=023f78a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f78a0",
  null
  
)

export default component.exports